export const emptyAdditionalTermsForm = {
  bonusesTxt: '',
  adminCostsTxt: '',
  infrastructureTxt: '',
  // [MCV-1543] Present so the Extra Terms field is controlled from first
  // render, like its three siblings.
  extraTxt: '',
};
